import { Component, Input } from '@angular/core';

// Determines from the icon label whether mat-icon or ca-icon is used.
// Usage: <memo-action-icon [iconLabel]="action?.type | actionicon"></memo-action-icon>
@Component({
  styleUrls: ['./memo-action-icon.component.scss'],
  templateUrl: './memo-action-icon.component.html',
  selector: 'memo-action-icon',
})
export class MemoActionIconComponent {
  public isCaIcon: boolean;
  public _iconLabel: string;

  @Input() purpose: 'memo' | 'announcement';

  @Input()
  set iconLabel(val: string) {
    this._iconLabel = val;
    this.isCaIcon = this.iconLabel.startsWith('ca-');
  }
  get iconLabel() {
    return this._iconLabel;
  }
}
